import React, { Fragment } from 'react';
import Navbar2 from '../../components/Navbar2'
import PageTitle from '../../components/pagetitle'
import Scrollbar from '../../components/scrollbar'

import Logo from '../../images/logo-nmf.png'
import Footer from '../../components/footer';

const RefundPolicy = () => {

    return (
        <Fragment>
            <Navbar2 Logo={Logo} />
            <PageTitle pageTitle={'Refund Policy'} />
            <section className="wpo-service-single-section ">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-12">
                            <div className="wpo-service-single-wrap">
                                <div className="wpo-service-single-content">
                                    <div className="wpo-service-single-content-des">
                                        <p>
                                            Donations made to Nimal Maula Foundation are voluntary contributions
                                            toward our charitable initiatives. As these funds are allocated to our
                                            programs upon receipt, <strong>donations are non-refundable and cannot
                                            be cancelled once a transaction has been processed.</strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default RefundPolicy;
